import { useTransitionStyles as s } from "../../../../node_modules/@floating-ui/react/dist/floating-ui.react.js";
const i = (r) => {
  const t = "0.3s", { isMounted: n, styles: o } = s(r, {
    initial: {
      transform: "translateY(-2rem)",
      opacity: 0,
      transition: `transform ${t}, opacity ${t}`
    },
    open: {
      transform: "translateY(0)",
      opacity: 1,
      transition: `transform ${t}, opacity ${t}`
    },
    close: {
      transform: "translateY(-2rem)",
      opacity: 0,
      transition: `transform ${t}, opacity ${t}`
    }
  });
  return { isMounted: n, styles: o };
};
export {
  i as useSlideTransition
};
//# sourceMappingURL=useSlideTransition.js.map
